// External packages
import * as React from 'react';

// Components
import { Checkbox } from 'components/Checkbox';
import { Button } from 'components/Button';
import { Icon } from 'components/Icons';

// Modules
import { DeleteConfirmationModal } from 'modules/DeleteConfirmationModal';

export interface BulkActionsToolbarProps {
  allSelected: boolean;
  someSelected: boolean;
  selectedCount: number;
  onSelectAll: (checked: boolean) => void;
  onBulkDelete: () => void;
  isDeleteModalOpen: boolean;
  setDeleteModalOpen: (open: boolean) => void;
  isDeleting?: boolean;
  label?: string;
}

export const BulkActionsToolbar: React.FC<BulkActionsToolbarProps> = ({
  allSelected,
  someSelected,
  selectedCount,
  onSelectAll,
  onBulkDelete,
  isDeleteModalOpen,
  setDeleteModalOpen,
  isDeleting,
  label = 'Odaberi sve',
}) => (
  <div className="flex justify-between gap-4 mt-4 flex-wrap">
    <Checkbox
      isSelected={allSelected}
      isIndeterminate={someSelected}
      onChange={(checked) => onSelectAll(!!checked)}
      className="ml-4"
    >
      {label}
    </Checkbox>
    <DeleteConfirmationModal
      modalTrigger={
        <Button
          variant="ghost"
          colorScheme="tertiary"
          isDisabled={selectedCount === 0}
        >
          <Icon name="trash" /> Obriši odabrano
        </Button>
      }
      onDelete={onBulkDelete}
      isOpen={isDeleteModalOpen}
      onOpenChange={setDeleteModalOpen}
      isPending={isDeleting}
    />
  </div>
);
